var _rect, _path, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoolBnbTada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 44,
    viewBox: "0 0 71 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    y: 3,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.827 31.4181V34.6121L19.0426 36.25L16.34 34.6121V31.4181L19.0426 33.056L21.827 31.4181ZM6.92188 20.3621L9.62446 22V27.4871L14.2926 30.2715V33.4655L6.92188 29.125V20.3621ZM31.1632 20.3621V29.125L23.7107 33.4655V30.2715L28.3788 27.4871V22L31.1632 20.3621V20.3621ZM23.7107 16.0215L26.4951 17.6595V20.8534L21.827 23.6379V29.2069L19.1245 30.8448L16.4219 29.2069V23.6379L11.59 20.8534V17.6595L14.3745 16.0215L19.0426 18.806L23.7107 16.0215V16.0215ZM11.59 23.1465L14.2926 24.7845V27.9784L11.59 26.3405V23.1465ZM26.4951 23.1465V26.3405L23.7926 27.9784V24.7845L26.4951 23.1465ZM9.62446 13.2371L12.4089 14.875L9.62446 16.5129V19.7069L6.92188 18.069V14.875L9.62446 13.2371V13.2371ZM28.4607 13.2371L31.2451 14.875V18.069L28.4607 19.7069V16.5129L25.7581 14.875L28.4607 13.2371V13.2371ZM19.0426 13.2371L21.827 14.875L19.0426 16.5129L16.34 14.875L19.0426 13.2371V13.2371ZM19.0426 7.75L26.4951 12.0905L23.7926 13.7284L19.1245 10.944L14.3745 13.7284L11.6719 12.0905L19.0426 7.75V7.75Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.1875,
    y: 3,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#BF00FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1875,
    y: 3,
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint0_radial_1_409)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1875,
    y: 3,
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint1_radial_1_409)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1875,
    y: 3,
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint2_radial_1_409)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1875,
    y: 3,
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint3_radial_1_409)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1875,
    y: 3,
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint4_radial_1_409)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7964 13.2922H55.6026C55.5023 13.2891 55.403 13.3126 55.3154 13.3603C55.2278 13.408 55.1553 13.478 55.1056 13.5629L52.2231 18.4496C52.1918 18.5051 52.1458 18.5513 52.0898 18.5835C52.0338 18.6158 51.97 18.6328 51.905 18.6328C51.84 18.6328 51.7761 18.6158 51.7202 18.5835C51.6642 18.5513 51.6182 18.5051 51.5869 18.4496L48.7143 13.5629C48.6646 13.478 48.5921 13.408 48.5045 13.3603C48.417 13.3126 48.3177 13.2891 48.2173 13.2922H42.169C42.0685 13.288 41.9688 13.3111 41.881 13.3589C41.7932 13.4067 41.7208 13.4773 41.672 13.5629L38.9684 18.1983C38.9197 18.2812 38.8947 18.3752 38.8958 18.4706C38.8969 18.5661 38.9242 18.6595 38.9749 18.7413C39.0255 18.823 39.0977 18.8902 39.1839 18.9358C39.2701 18.9814 39.3673 19.0038 39.4654 19.0007H44.649C44.7953 19.0007 44.9356 19.0572 45.039 19.1578C45.1425 19.2584 45.2006 19.3949 45.2006 19.5372V19.6484C45.201 19.76 45.1719 19.8698 45.1161 19.9674L42.005 25.2843C41.9584 25.3656 41.934 25.4571 41.934 25.5502C41.934 25.6432 41.9584 25.7347 42.005 25.816L44.7235 30.437C44.7717 30.5194 44.8414 30.5879 44.9257 30.6356C45.0099 30.6832 45.1056 30.7084 45.2031 30.7084C45.3006 30.7084 45.3963 30.6832 45.4805 30.6356C45.5648 30.5879 45.6345 30.5194 45.6827 30.437L51.5869 20.3541C51.6193 20.2999 51.6657 20.2549 51.7215 20.2237C51.7773 20.1924 51.8406 20.1759 51.905 20.1759C51.9694 20.1759 52.0327 20.1924 52.0885 20.2237C52.1443 20.2549 52.1907 20.2999 52.2231 20.3541L55.0956 25.2457C55.1453 25.3305 55.2179 25.4005 55.3054 25.4482C55.393 25.4959 55.4923 25.5195 55.5926 25.5164H55.7964C55.8967 25.5195 55.996 25.4959 56.0836 25.4482C56.1712 25.4005 56.2437 25.3305 56.2934 25.2457L59.2753 20.1656C59.4098 19.9323 59.48 19.6692 59.4791 19.4018C59.4793 19.1361 59.4091 18.8747 59.2753 18.643L56.2934 13.5629C56.2437 13.478 56.1712 13.408 56.0836 13.3603C55.996 13.3126 55.8967 13.2891 55.7964 13.2922Z",
    fill: "url(#paint5_linear_1_409)",
    shapeRendering: "crispEdges"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 1.8125,
    width: 40.375,
    height: 40.375,
    rx: 20.1875,
    stroke: "#1D1D27",
    strokeWidth: 2.375
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1_409",
    x: 24.4698,
    y: -0.782384,
    width: 49.4351,
    height: 46.2685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.46296
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_409"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.351852
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.21296
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1_409",
    result: "effect2_dropShadow_1_409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_409",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.8975 46.035) rotate(-130.274) scale(25.2766 23.2962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC5DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5DF6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.0775 37.39) rotate(-144.737) scale(23.0371 20.6028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0775 35.49) rotate(-47.7263) scale(24.0087 27.121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00A9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8825 -1.18) rotate(104.611) scale(22.9729 29.8674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4825 10.03) rotate(24.1265) scale(26.9601 24.8478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_409",
    x1: 49.1933,
    y1: 11.0936,
    x2: 49.1933,
    y2: 32.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_409"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.1875,
    y: 3,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolBnbTada);
export default __webpack_public_path__ + "static/media/pool-bnb-tada.18bde917e62ccc25d3ba1641ccaeaaf3.svg";
export { ForwardRef as ReactComponent };